import {combineReducers} from 'redux'
import admin from './Admin.reducer.js'
import user from './User.reducer.js'
import users from './Users.reducer.js'

export default combineReducers({
  user,
  users
})
